import { apiBaseAssets } from "../config/api";
import lc from "../utils/language";
import { useEffect, useState } from "react";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}
export const About = ({ data, isRtl }) => {
  const isDesktop = useMediaQuery('(min-width: 991px)');

  return (
    <div id="about" style={{ backgroundColor: "#111" }}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12" style={{ textAlign: 'center' }}>
            <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}>
              {data[lc("title", isRtl)]}
            </h2>
          </div>
          <div className="col-xs-12 col-md-12" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div className="col-xs-6 col-md-3" style={{ textAlign: 'center' }}>
              <img
                src={`${apiBaseAssets}${data.background}`}
                className="img-responsive"
                alt=""
              />
            </div>
            <div className="col-xs-12 col-md-9">
              <p style={{ textAlign: 'justify', fontFamily: isRtl ? "amiriRegular" : "Open Sans", lineHeight: '36px', color: 'rgba(242, 242, 242,0.7)' }}>
                {data.subTitle ? data[lc("subTitle", isRtl)] : "About Us"}
              </p>
              <div className="col-xs-12 col-md-12">
                <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff', textAlign: 'start' }}>
                  {data.why ? data[lc("why", isRtl)] + '?' : "Why US?"}
                </h3>
                <div className="list-style">
                  <div style={{ padding: 0 }}>
                    <ul style={{ listStyle: 'none', display: 'flex', justifyContent: 'space-between', flexDirection: isDesktop ? 'row' : 'column', gap: !isDesktop ? '5px' : null, flexWrap: 'wrap' }}>
                      {data.whyFactors.slice(0, 6).length > 0
                        ? data.whyFactors.slice(0, 6).map((d, i) => (
                          <li
                            style={{
                              fontFamily: isRtl ? "amiriBold" : "Open Sans", fontSize: '16px', fontWeight: 'bold',
                              display: 'flex', gap: '5px',
                              alignItems: 'baseline'
                            }}
                            key={d._id}
                          >
                            {/* <img src="img/Rectangle 43.png" style={{ width: '32px', height: '32px' }} /> */}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="16" height="16" rx="16" fill="#7FB6FF" />
                            </svg>

                            {d[lc("title", isRtl)]}
                          </li>
                        ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="col-xs-12 col-md-12">

          </div> */}
          {/* <div className="col-xs-12 col-md-6">
            <img
              src={`${apiBaseAssets}${data.background}`}
              className="img-responsive"
              alt=""
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}>
                {data[lc("title", isRtl)]}
              </h2>
              <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}>
                {data.subTitle ? data[lc("subTitle", isRtl)] : "About Us"}
              </p>
              <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}>
                {data.why ? data[lc("why", isRtl)] : "Why US"}
              </h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data.whyFactors.slice(0, 6).length > 0
                      ? data.whyFactors.slice(0, 6).map((d, i) => (
                          <li
                            style={{
                              fontFamily: isRtl ? "amiriBold" : "Open Sans",
                            }}
                            key={d._id}
                          >
                            {d[lc("title", isRtl)]}
                          </li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {data.whyFactors.slice(6, 12).length > 0 &&
                      data.whyFactors.slice(6, 12).map((d, i) => (
                        <li
                          style={{
                            fontFamily: isRtl ? "amiriBold" : "Open Sans",
                          }}
                          key={d._id}
                        >
                          {d[lc("title", isRtl)]}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
